module.exports = __webpack_public_path__ + "static/media/igloo.7b460e26.svg";